import { getSettingAppMigrationAvailable } from "@faire/marketplace-lib/settings/getSettingAppMigrationAvailable";
import { isMobileApp } from "@faire/marketplace-lib/utils/isMobileApp";
import { useQuery as useIsAppInstalledQuery } from "@faire/web-api--source/endpoints/www/api/page-data/is-app-installed/get-hooks";

export const useShowContextualAppDownloadCTAs = () => {
  const { data } = useIsAppInstalledQuery();
  const showContextualAppDownloadCTAs =
    data?.is_app_installed === false &&
    !isMobileApp() &&
    getSettingAppMigrationAvailable();

  return { showContextualAppDownloadCTAs };
};
